<div class="modal-footer-container">
  @for (action of configModel.actions$(); track action.name) {
    <button mat-flat-button
            *ngIf="!action.hidden"
            [disabled]="action.disabled"
            (click)="onActionClicked(action.name)"
            [ngClass]="action.classNames">
      {{action.label | translate}}
    </button>
  }
</div>
